import React, { useEffect, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { useNavigate } from "react-router-dom";
import AWSManagerSingleton from "../../Utility/AWS/AWSManagerSingleton";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const navigate = useNavigate();
  const awsManagerSingleton = new AWSManagerSingleton();

  useEffect(() => {
    sessionStorage.setItem("Logged", false);
    awsManagerSingleton.UseCognito(
      "eu-west-1",
      process.env.REACT_APP_COGNITO_USER_POOL_ID,
      process.env.REACT_APP_COGNITO_CLIENT_ID,
      process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID
    );
  }, []);

  const handleLogin = async () => {
    try {
      const result = await awsManagerSingleton.CognitoAuthenticateUser(
        username,
        password
      );
      if (result) {
        sessionStorage.setItem("username", username);
        sessionStorage.setItem("Logged", true);
        //need to get user attributes to see if user is admin or not

        //navigate to client-plant choice page giving attributes as prop
        navigate("/clientPlantChoice");
        //navigate("/endProcess");
      }
    } catch (error) {
      console.error(error);
      alert("Wrong Username or Password");
    }
  };

  const handleForgot = async () => {
    try {
      await awsManagerSingleton.CognitoForgotPassword(username);
      navigate(`/forgottenPassword?username=${encodeURIComponent(username)}`);
    } catch (error) {
      console.error("Error Forgot Password:", error);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        //background: "linear-gradient(to right, #ffffff 30%, #E31E24 100%)",
        background: "rgba(227, 30, 36, 0.9)", // 👈 Red with transparency
        padding: "20px",
      }}
    >
       <img
            src="/pms/cannonOrizzontaleBianco.png"
            alt="Cannon"
            style={{ width: "25rem"}}
          />
      <Card
        style={{
          width: "100%",
          maxWidth: "400px",
          padding: "2rem",
          borderRadius: "1rem",
          boxShadow: "0 8px 24px rgba(227, 30, 36, 0.3)",
          background: "#fff",
          textAlign: "center",
        }}
      >
        <h2 style={{ marginBottom: "1.5rem"}}>Login</h2>

        <div style={{ marginBottom: "1rem" }}>
          <InputText
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Username"
            style={{
              width: "100%",
              padding: "0.75rem",
              borderRadius: "0.5rem",
              border: "1px solid #ccc",
            }}
          />
        </div>

        <div style={{ marginBottom: "1.5rem" }}>
          <InputText
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            style={{
              width: "100%",
              padding: "0.75rem",
              borderRadius: "0.5rem",
              border: "1px solid #ccc",
            }}
          />
        </div>

        <Button
          label="Login"
          onClick={handleLogin}
          style={{
            width: "100%",
            padding: "0.75rem",
            background: "#E31E24",
            border: "none",
            borderRadius: "0.5rem",
            color: "#fff",
            fontWeight: "bold",
            transition: "background 0.3s",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.background = "#C2181C")}
          onMouseLeave={(e) => (e.currentTarget.style.background = "#E31E24")}
        />

        <Button
          label="Forgot Password"
          onClick={handleForgot}
          style={{
            width: "100%",
            marginTop: "1rem",
            padding: "0.75rem",
            background: "#FF6F61",
            border: "none",
            borderRadius: "0.5rem",
            color: "#fff",
            fontWeight: "bold",
            transition: "background 0.3s",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.background = "#E85C50")}
          onMouseLeave={(e) => (e.currentTarget.style.background = "#FF6F61")}
        />
      </Card>
    </div>
  );
};

export default Login;
